/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendD9KpiResponseDto } from '../../models/backend-d-9-kpi-response-dto';

export interface GetKpiDashboardsD9KpiGet$Params {
  /**
   * ID проекта (обязательно)
   */
  project_id: number;

  /**
   * ID сценария; если не задан — берётся активный по проекту
   */
  scenario_id?: number | null;

  /**
   * Начало периода YYYY-MM-DD; дефолт — последние 12 месяцев данных
   */
  from?: string | null;

  /**
   * Конец периода YYYY-MM-DD; дефолт — последняя дата данных
   */
  to?: string | null;
}

export function getKpiDashboardsD9KpiGet(
  http: HttpClient,
  rootUrl: string,
  params: GetKpiDashboardsD9KpiGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendD9KpiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getKpiDashboardsD9KpiGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendD9KpiResponseDto>;
    }),
  );
}

getKpiDashboardsD9KpiGet.PATH = '/dashboards/d9/kpi';
